export default __webpack_public_path__ + "static/media/pw-background-plane-shiny.2240544d.png";